
import {Component, Vue} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import DialogConfirm from '@/components/DialogConfirm.vue';
import {swalSuccess, swalError} from '@/plugins/swal';

@Component({
  components: {
    DialogConfirm,
  },
})
export default class FormEducation extends mixins(LoadingMixin, SnackbarMixin) {
  getColor(status: number) {
    return status === 1 ? 'success' : 'error';
  }
  showAddFrom = false;
  listExperience = [];
  isLoading = false;
  dialog = false;
  async mounted() {
    await this.facthData();
  }
  async deleteItem(item: any) {
    const confirmed = await this.$dialog.delete();

    if (confirmed) {
      try {
        const {message} = await this.$store.dispatch(
          'jobExperience/delete',
          item,
        );
        this.handleSuccess(message);
        this.facthData();
      } catch (e) {
        this.catchError(e);
      }
    }
  }
  async onSkipHistoryJob() {
    try {
      this.startLoading('saving');
      const res = await this.$store.dispatch('jobExperience/create', {
        position: '',
        company: '',
        description: '',
        city: '',
        start_date: null,
        end_date: null,
        is_fresh_graduate: true,
      });
      this.finishLoading('saving');
      if (res.status === 200) {
        swalSuccess.fire({
          title: 'Success!',
          text: res.data.message,
        });

        setTimeout(() => this.$router.push('/upload'), 500);
      } else {
        this.dialog = false;
        this.$dialog.error(res.error.message);
      }
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
  async facthData() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('jobExperience/all');
      this.finishLoading('detail');

      this.listExperience = data;
      this.dialog = !this.listExperience.length;
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.catchError(e);
    }
  }
}
